import styled, { keyframes } from 'styled-components';
import { backgroundTheme, media } from '../../styles/style-utils';

export const StyledWrapper = styled.div`
  padding: 0 0 4rem 0;
  background: white;

  > section {
    padding: 1rem 2rem;
  }
`;

export const HeaderSection = styled.section`
  padding: 8rem 1rem;
  margin: 5rem 0 4rem 0;
  position: relative;
`;

export const BackLinkWrap = styled.div`
  position: absolute;
  display: block;
  width: 100px;
  font-size: 2rem;
  line-height: 2rem;
  padding: 1rem;
  top: -5rem;
  left: 0;
  border-bottom: 1px solid black;

  > a {
    color: black;
  }
`;



// WEBPACK FOOTER //
// ./src/templates/DietTemplate/DietTemplateStyles.js